import { QueryVariablePreprocessor } from './initialQueryVariableProcessors.types';
import { useCallback } from 'react';
import { useDataTableSearchParams } from '../useDataTableSearchParams';
import { OnVariablesChanged } from '../DataTableQuery.types';

/**
 *  Retrieves the initial parameters from the URL or local storage.
 */
export function useStorageProcessor(): QueryVariablePreprocessor.Function {
  const { initialParams } = useDataTableSearchParams();
  return useCallback(
    () => ({
      result: { ...initialParams } as OnVariablesChanged<any, any>,
      status: QueryVariablePreprocessor.Status.COMPLETED
    }),
    [initialParams]
  );
}
